import Link from 'redux-first-router-link'

import KeyValues, { KeyValue } from 'components/KeyValues'

function getWorkflowState(issue) {
  return issue.workflowState || issue.state || {}
}

export default function LinkedLinearIssueFields({ issue }) {
  const { identifier, url, id: issueId } = issue || {}
  const workflowState = getWorkflowState(issue || {})

  return (
    <KeyValues>
      <KeyValue singleline title="Identifier" value={identifier || issueId} />
      <KeyValue
        singleline
        title="Workflow state"
        value={workflowState.name || ''}
      />
      {url && (
        <KeyValue
          singleline
          title="Open destination"
          value={
            <Link target="_blank" rel="noopener noreferrer" to={url}>
              Open in Linear
            </Link>
          }
        />
      )}
    </KeyValues>
  )
}
